import { getCopiesByGroup } from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/helpers'

export const getFirstCopyKey = group => getCopiesByGroup(group)[0]?.key
